import { createFileRoute } from "@tanstack/react-router";

import {
  guardAgbwFeature,
  redirectToClientOverview,
} from "@/core/lib/feature-guards";

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/_client-tabs/agbw-overview",
)({
  beforeLoad: ({ context: { active }, params }) => {
    if (!guardAgbwFeature(active).allowed) {
      redirectToClientOverview(params.id);
    }
  },
});
